import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {ApiService} from 'src/app/services/api.service';
import {ErrorHelper} from '../../common/ErrorHelper';

export interface LogLine {
  timestamp: Date;
  status: string;
  context: string;
  message: string;
}

@Component({
  selector: 'app-logs',
  templateUrl: './dynamic-image-logs.component.html',
  styleUrls: ['./dynamic-image-logs.component.scss']
})
export class DynamicImageLogsComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['timestamp', 'status', 'context', 'message'];
  dataSource: LogLine[];

  constructor(
    private apiService: ApiService,
    private notifierService: NotifierService) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.loadDataAsync();
  }

  async loadDataAsync(): Promise<any> {
    try {
      await this.loadLogLines();
    } catch (error) {
      console.log(error);
    }
  }

  loadLogLines(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getDynamicImageLog().toPromise().then((data) => {
        this.dataSource = data;
        console.log('Fetched all the log lines');
        resolve(true);
      }).catch(error => {
        const errorMessage = ErrorHelper.disectError('load log lines', error);
        this.notifierService.notify('error', errorMessage);
        resolve(false);
      });
    });
  }

}
